<template>
  <WizardContent
    :graphic="{
      type: 'gradient',
      assetsPath: 'image-paused',
    }"
  >
    <h4 class="mt-6 mb-9">
      Your trial is currently paused
    </h4>
    <p class="p3">
      Hi {{ firstName }}, we've received a request to place your JobNav trial on pause.
      To begin your trial again, please reach out to
      {{
        accountExecutiveName
          ? `your account representative ${accountExecutiveName}`
          : 'us'
      }} at {{ accountExecutiveEmail || 'hello@datapeople.io' }} or use the chat widget below.
    </p>
  </WizardContent>
</template>

<script>
import WizardContent from '@/components/shared/WizardContent.vue';
import { mapState } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';

export default {
  name: 'TrialPaused',
  components: {
    WizardContent,
  },
  emits: ['track-page-load'],
  computed: {
    ...mapState(useWizard, ['firstName', 'accountExecutiveName', 'accountExecutiveEmail']),
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Trial Paused' });
  },
};
</script>
